import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.link-disabled]': 'linksDisabled',
    '[class.has-no-bottom-padding]': 'hasNoBottomPadding',
    '[class.has-hover-state]': 'hasHoverState',
    '[class.connected-on-bottom]': 'connectedOnBottom',
    '[class.connected-on-top]': 'connectedOnTop',
    '[class]': 'variant',
  },
  standalone: true,
})
export class BoxComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'raised-higher',
      'no-radius',
      'background',
      'background-light',
      'background-light-blue',
      'border-light',
      'clickable',
      'no-padding',
      'padding-small',
      'horizontal',
      'vertical',
      'no-radius',
      'no-background',
      'no-border',
      'border-top',
      'no-border-bottom',
    ],
  ];
  @ComponentVariant(BoxComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public linksDisabled: boolean = false;
  @Input() public hasNoBottomPadding: boolean = false;
  @Input() public hasHoverState: boolean = false;
  @Input() public connectedOnTop: boolean = false;
  @Input() public connectedOnBottom: boolean = false;

  constructor(public elRef: ElementRef) {}
}
